/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";

/**
 *
 * @export
 * @interface RelatedPickupSummary
 */
export interface RelatedPickupSummary {
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  carrierPickupNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  billOfLadingNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  businessName?: string | null;
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  addressLines?: string | null;
  /**
   *
   * @type {string}
   * @memberof RelatedPickupSummary
   */
  cityProvincePostalCode?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof RelatedPickupSummary
   */
  pickupDate?: LocalDate | null;
  /**
   *
   * @type {ShipmentState}
   * @memberof RelatedPickupSummary
   */
  state?: ShipmentState | null;
  /**
   *
   * @type {boolean}
   * @memberof RelatedPickupSummary
   */
  isSameCarrier: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RelatedPickupSummary
   */
  isSamePickupDate: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RelatedPickupSummary
   */
  isSameStreetAddress: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RelatedPickupSummary
   */
  mentionedInCancelEmail: boolean;
}

/**
 * Check if a given object implements the RelatedPickupSummary interface.
 */
export function instanceOfRelatedPickupSummary(
  value: object,
): value is RelatedPickupSummary {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("isSameCarrier" in value) || value["isSameCarrier"] === undefined)
    return false;
  if (!("isSamePickupDate" in value) || value["isSamePickupDate"] === undefined)
    return false;
  if (
    !("isSameStreetAddress" in value) ||
    value["isSameStreetAddress"] === undefined
  )
    return false;
  if (
    !("mentionedInCancelEmail" in value) ||
    value["mentionedInCancelEmail"] === undefined
  )
    return false;
  return true;
}

export function RelatedPickupSummaryFromJSON(json: any): RelatedPickupSummary {
  return RelatedPickupSummaryFromJSONTyped(json, false);
}

export function RelatedPickupSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RelatedPickupSummary {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    carrierPickupNumber:
      json["carrierPickupNumber"] == null
        ? undefined
        : json["carrierPickupNumber"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    businessName:
      json["businessName"] == null ? undefined : json["businessName"],
    addressLines:
      json["addressLines"] == null ? undefined : json["addressLines"],
    cityProvincePostalCode:
      json["cityProvincePostalCode"] == null
        ? undefined
        : json["cityProvincePostalCode"],
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    state:
      json["state"] == null ? undefined : ShipmentStateFromJSON(json["state"]),
    isSameCarrier: json["isSameCarrier"],
    isSamePickupDate: json["isSamePickupDate"],
    isSameStreetAddress: json["isSameStreetAddress"],
    mentionedInCancelEmail: json["mentionedInCancelEmail"],
  };
}

export function RelatedPickupSummaryToJSON(json: any): RelatedPickupSummary {
  return RelatedPickupSummaryToJSONTyped(json, false);
}

export function RelatedPickupSummaryToJSONTyped(
  value?: RelatedPickupSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    carrierIdentifier: value["carrierIdentifier"],
    carrierPickupNumber: value["carrierPickupNumber"],
    billOfLadingNumber: value["billOfLadingNumber"],
    businessName: value["businessName"],
    addressLines: value["addressLines"],
    cityProvincePostalCode: value["cityProvincePostalCode"],
    pickupDate: value["pickupDate"],
    state: ShipmentStateToJSON(value["state"]),
    isSameCarrier: value["isSameCarrier"],
    isSamePickupDate: value["isSamePickupDate"],
    isSameStreetAddress: value["isSameStreetAddress"],
    mentionedInCancelEmail: value["mentionedInCancelEmail"],
  };
}
